import { Container, type ContainerProps, Stack } from '@vesyl/ui/chakra'
import type { ReactNode } from 'react'

interface SettingsContainerProps extends Omit<ContainerProps, 'children'> {
  children: ReactNode
}

export function SettingsContainer({ children, ...props }: SettingsContainerProps) {
  return (
    <Container maxW="4xl" px="6" mt="8" mx="auto" mb="8" {...props}>
      <Stack gap="8">{children}</Stack>
    </Container>
  )
}
